export const VALIDATE_BEGIN = 'validate_begin';
export const VALIDATE_SUCCESS = 'validate_success';
export const VALIDATE_ERROR = 'validate_error';